// src/components/Topbar.js
import React from "react";
import { useNavigate } from "react-router-dom";

function Topbar() {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Remove JWT tokens from localStorage
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    // Redirect to admin login page
    navigate("/admin-login");
  };

  return (
    <div
      className="topbar"
      style={{
        backgroundColor: "#f1f5f9",
        padding: "10px 20px",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      }}
    >
      <button
        onClick={handleLogout}
        style={{
          padding: "6px 12px",
          backgroundColor: "#ef4444",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          transition: "background 0.2s",
        }}
        onMouseOver={(e) => (e.target.style.backgroundColor = "#dc2626")}
        onMouseOut={(e) => (e.target.style.backgroundColor = "#ef4444")}
      >
        Logout
      </button>
    </div>
  );
}

export default Topbar;